import { DashboardContainer } from './../../dashboard.container';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-user-chatroom',
    templateUrl: 'chatroom.component.html',
    styleUrls: ['chatroom.component.css']
})

export class ChatroomComponent implements OnInit {

    hiddenPeriod = true;
    messages;
    selectedMessage;
    sidebarInfo;
    options = ['Most recent', 'Username Ascending', 'Username Descending'];

    backendRoot = environment.backendRoot;
    searchText = '';
    chatFilters = {startDate: new Date(1970).getTime(), endDate: new Date().getTime(), searchText: ''};
    checkin;
    checkout;
    updated;
    startDate;
    endDate;

    userText = '';

    constructor(private dashboardContainer: DashboardContainer) { }

    ngOnInit() {
        this.dashboardContainer.changeHeader();
        this.dashboardContainer.getUsersMessages()
            .subscribe(msgs => {
                this.messages = msgs;
                this.sortMessaging('Most recent');
                this.selectedMessage = this.messages[0];
                this.getImgUrl();
            });
        this.startDate = this.chatFilters.startDate;
        const cd = new Date();
        this.endDate = cd.getDate() + '/' + (cd.getMonth() + 1) + '/' + cd.getFullYear();
        this.startDate = cd.getDate() + '/' + (cd.getMonth() + 1) + '/' + (cd.getFullYear() - 1);
        this.chatFilters.startDate = new Date(cd.getFullYear() - 1, cd.getMonth(), cd.getDate()).getTime();
    }

    sortMessaging(sortby) {
        if (sortby === 'Most recent') {
            this.messages = this.messages.sort((a, b) =>  b.modified - a.modified);
            this.getImgUrl();
        } else if (sortby === 'Username Ascending') {
            this.messages = this.messages.sort((a, b) => {
                if (a.hotelName > b.hotelName) {return 1; }
                if (a.hotelName < b.hotelName) {return -1; }
                return 0;
            });
            this.getImgUrl();
        } else if (sortby === 'Username Descending') {
            this.messages = this.messages.sort((a, b) => {
                if (a.hotelName > b.hotelName) {return -1; }
                if (a.hotelName < b.hotelName) {return 1; }
                return 0;
            });
            this.getImgUrl();
        }
        this.selectedMessage = this.messages[0];
    }

    togglePeriodCard() {
        this.hiddenPeriod = !this.hiddenPeriod;
    }

    getDate(date) {
        return new Date(date);
    }

    getUserThumbnail(message) {
        let usrPic = '../../../../../assets/img/unknown_quotes.jpg';
        if (message.userId) {
            if (message.userId.photo) {
                usrPic = 'data:image/png;base64,' + message.userId.photo;
            }
        } else if (message.customerId) {
            if (message.customerId.photo) {
                usrPic = 'data:image/png;base64,' + message.customerId.photo;
            }  else {
                usrPic = this.backendRoot + '/webresources/frontend/entity.users/avatar/thumbnail/' + message.customerId.id;
            }

        }
        return usrPic;

    }

    getImgUrl() {
        this.sidebarInfo = new Array<any>();
        this.messages.forEach(selectedMessage => {
            const lastMsg = selectedMessage.messageCollection[selectedMessage.messageCollection.length - 1];
            let lastThumbnail = '../../../../../assets/img/unknown_quotes.jpg';
            let usrName = '';
            if (lastMsg.userId ) {
                if (lastMsg.userId.photo) {
                    lastThumbnail = 'data:image/png;base64,' + lastMsg.userId.photo;
                }
                usrName = lastMsg.userId.nickname + ' ' + lastMsg.userId.lastName;
            } else if (lastMsg.customerId) {
                if (lastMsg.customerId.photo !== null) {
                    lastThumbnail = this.backendRoot + '/webresources/frontend/entity.users/avatar/thumbnail/' + lastMsg.customerId.id;
                }
                usrName = lastMsg.customerId.name + ' ' + lastMsg.customerId.surname;
            }
            const dateSent = new Date(lastMsg.timeSent);
            this.sidebarInfo.push({lastThumbnail: lastThumbnail, dateSent: dateSent});

        });

    }

    setSelectedThread(id) {
        this.selectedMessage = this.messages.find(message => message.id === id);

    }

    onSearchChange(text) {
        this.chatFilters.searchText = text;
        if (this.checkin !== undefined && this.checkout !== undefined) {
            this.chatFilters.startDate = new Date(this.checkin.year, this.checkin.month - 1, this.checkin.day).getTime();
            this.chatFilters.endDate = new Date(this.checkout.year, this.checkout.month - 1, this.checkout.day).getTime();
        }
        this.updated = new Date();
    }

    filterMassages() {
        /**
         * @TODO: Implement filter function or pipe
         */
        if (this.checkin === undefined || this.checkout === undefined) { return; }

        this.chatFilters.startDate = new Date(this.checkin.year, this.checkin.month - 1, this.checkin.day).getTime();
        this.chatFilters.endDate = new Date(this.checkout.year, this.checkout.month - 1, this.checkout.day + 1).getTime();

        const sd = new Date(this.checkin.year, this.checkin.month - 1, this.checkin.day);
        const ed = new Date(this.checkout.year, this.checkout.month - 1, this.checkout.day + 1);

        this.endDate = ed.getDate() + '/' + (ed.getMonth() + 1) + '/' + ed.getFullYear();
        this.startDate = sd.getDate() + '/' + (sd.getMonth() + 1) + '/' + (sd.getFullYear() - 1);

        this.updated = new Date();
    }

    sendMessage() {
        const message = {
            customerId: 0,
            read: false,
            seqNo: this.selectedMessage.messageCollection[this.selectedMessage.messageCollection.length - 1].seqNo + 1,
            text: this.userText,
            threadId: this.selectedMessage.id,
            timeSent: new Date().getTime()
        };
        this.userText = '';
        this.dashboardContainer.sendMessage(message).subscribe(reply => {
            let selectedThread = this.messages.find(msg => msg.id === reply.id).messageCollection ;
            selectedThread = reply;
            this.selectedMessage = selectedThread;
            this.chatFilters.endDate = new Date().getTime();
        });
    }

    deleteMessageThread(threadId) {
        // return;
        this.dashboardContainer.deleteMessageThread(threadId).subscribe(reply => {
            console.log(reply);
        });
    }
}
